module.exports = "<p><b>Pick-up</b></p>\r\n<p>We offer free pick-up points throughout Belgium and the Netherlands.</p>\r\n<p>You can find all pick-up points on the map. For each pick-up point you can see the frequenty of the supply and also when you can pick up:</p>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/shipping/en_pre.html
// module id = 4LUd
// module chunks = 1